var _defs, _path, _path2, _path3, _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddBorderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 356",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".add-border-icon-cls-1{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:28px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "add-border-icon-cls-1",
    d: "m205.21,22.57h108.3c13.81,0,25,11.19,25,25v84.85"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "add-border-icon-cls-1",
    d: "m19.49,132.42V47.57c0-13.81,11.19-25,25-25h109.11"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "add-border-icon-cls-1",
    d: "m153.61,293.84H44.49c-13.81,0-25-11.19-25-25v-84.92"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "add-border-icon-cls-1",
    x1: 222.21,
    y1: 267.28,
    x2: 394.51,
    y2: 267.28
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "add-border-icon-cls-1",
    x1: 308.36,
    y1: 181.13,
    x2: 308.36,
    y2: 353.43
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddBorderIcon);
export default __webpack_public_path__ + "static/media/add_border-icon.7a63003ebb2546273ad8f0abd8e87eff.svg";
export { ForwardRef as ReactComponent };